export const SET_FILTER_DATA = 'SET_FILTER_DATA'
export const SET_FILTER_GRAPH = 'SET_FILTER_GRAPH'
export const SET_FILTER = 'SET_FILTER'
export const REMOVE_FILTER = 'REMOVE_FILTER'
export const CLEAR_FILTER = 'CLEAR_FILTER'
export const UPDATE_LIMITATION = 'UPDATE_LIMITATION'
export const CLEAR_LIMITATION = 'CLEAR_LIMITATION'
export const SET_QUERY = 'SET_QUERY'
export const SEARCH = 'SEARCH'
export const PAGINATION = 'PAGINATION'
export const CLEAR_PAGINATION_LIMIT = 'CLEAR_PAGINATION_LIMIT'
export const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE'
export const SET_TYPE = 'SET_TYPE'
export const SET_FILE = 'SET_FILE'
export const SET_TABLE_FILTER = 'SET_TABLE_FILTER'
export const CLEAR_TABLE_FILTER = 'CLEAR_TABLE_FILTER'
export const REMOVE_TABLE_FILTER = 'REMOVE_TABLE_FILTER'
export const SET_QUERY_FILTER = 'SET_QUERY_FILTER'
export const SET_BUFFER_LINES = 'SET_BUFFER_LINES'

export function makeSearchParams (state, getters) {
  const { type, tableFilter } = state
  const params = {
    type,
    ...getters.getFilters(type),
    ...getters.getFilters('static')
  }
  if (state.file !== null) {
    params.file = state.file
  } else if (state.query !== '') {
    params.references = getters.getSplitQuery
  }
  Object.entries(tableFilter).forEach(([key, value]) => {
    if (value) {
      params[key] = value
    }
  })
  return params
}

export function makeQueryParams (params, state) {
  const query = { ...params }
  delete query.file
  query.page = state.pagination.current
  return query
}